import { CheckCircleRounded, ErrorRounded } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Avatar, Box, CircularProgress, Divider, List, ListItem, ListItemText, Stack, Tab, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { InspectionIcon } from 'app/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
function formatInspectionModeLabel(mode) {
    if (mode === 'defects_first') {
        return 'Акцент на важном (быстрый)';
    }
    return 'По умолчанию (подробный)';
}
function formatSummaryPositionLabel(mode, position) {
    if (mode !== 'defects_first') {
        return '—';
    }
    return position === 'start' ? 'В начале шаблона' : 'В конце шаблона';
}
const ChecklistInspectionViewItem = (props) => {
    var _a, _b, _c, _d;
    const { checkpoint = [], result, index } = props;
    const checkpointParts = checkpoint;
    const type = (_a = checkpointParts[0]) !== null && _a !== void 0 ? _a : '';
    const title = (_b = checkpointParts[1]) !== null && _b !== void 0 ? _b : '';
    const required = (_c = checkpointParts[3]) !== null && _c !== void 0 ? _c : false;
    const status = required ? !result : false;
    if (!type || !title)
        return null;
    // TODO: refactor later
    const safeReactNode = (value) => {
        if (React.isValidElement(value))
            return value;
        if (typeof value === 'string')
            return value;
        if (typeof value === 'number')
            return value.toString();
        if (typeof value === 'boolean')
            return value ? 'Да' : 'Нет';
        if (value === null || value === undefined)
            return '-';
        if (typeof value === 'object') {
            if (value.checked !== undefined) {
                if (typeof value !== 'boolean') {
                    return '-';
                }
                else {
                    return value.checked ? 'Да' : 'Нет';
                }
            }
            if (!Array.isArray(value) && Object.keys(value).length > 0) {
                console.error('Объект в текстовом поле:', value);
                return 'Некорректные данные';
            }
            return null;
        }
        return String(value);
    };
    switch (type) {
        case 'text':
        case 'number':
        case 'vehicle_mileage':
        case 'trailer_license_plate':
        case 'vehicle_license_plate':
        case 'date':
        case 'hose_check_date':
        case 'dk_tractor_date':
        case 'sr_un1203_date':
        case 'osago_date':
        case 'dopog_tractor_date':
        case 'tacho_calib_date':
        case 'fe_op2_date':
        case 'dk_ppc_date':
        case 'svid_poverka_date':
        case 'dopog_ppc_date':
        case 'fe_6kg_date':
        case 'first_aid_kit_date':
        case 'eye_wash_date':
        case 'instructions_date':
        case 'pipeline_calib_date':
        case 'drain_trap_date':
        case 'gnd_pin_qty':
        case 'resp_rpg67_a_qty':
        case 'select':
            return (React.createElement(ListItem, { "data-error": status, key: index },
                React.createElement(ListItemText, { primary: title }),
                React.createElement(ListItemText, { primary: safeReactNode(result) })));
        case 'textarea':
            return (React.createElement(ListItem, { key: index, "data-error": status, sx: (theme) => ({
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    padding: 0,
                    overflow: 'hidden',
                    '.MuiListItemText-root': {
                        width: '100%',
                        paddingTop: '8px',
                        paddingBottom: '12px',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        marginBottom: 0,
                        borderBottom: '1px solid',
                        borderColor: theme.palette.divider,
                    },
                    'p.MuiTypography-root': {
                        paddingTop: '8px',
                        paddingBottom: '12px',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                    },
                }) },
                React.createElement(ListItemText, { primary: title }),
                React.createElement(Typography, { component: 'p' }, (_d = safeReactNode(result)) !== null && _d !== void 0 ? _d : 'Нет данных')));
        case 'photo':
            return (React.createElement(ListItem, { key: index, "data-error": status, sx: (theme) => ({
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    padding: 0,
                    overflow: 'hidden',
                    '.MuiListItemText-root': {
                        width: '100%',
                        paddingTop: '8px',
                        paddingBottom: '12px',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        marginBottom: 0,
                        borderBottom: '1px solid',
                        borderColor: theme.palette.divider,
                    },
                }) },
                React.createElement(ListItemText, { primary: title }),
                React.createElement(Box, { component: 'div', sx: {
                        width: '100%',
                        height: '200px',
                        bgcolor: 'black',
                        'a, img': {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        },
                    } },
                    React.createElement("a", { href: `${location.origin}/resources/${result}`, target: '_blank' },
                        React.createElement("img", { src: `${location.origin}/resources/${result}`, alt: '' })))));
        case 'boolean':
            return typeof result === 'object' ? (React.createElement(React.Fragment, null,
                React.createElement(ListItem, { sx: () => ({
                        paddingLeft: '20px',
                        flexDirection: 'column',
                        alignItems: 'start',
                    }), "data-error": status, key: `${index}-checkbox` },
                    React.createElement(Box, { sx: () => ({
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                        }) },
                        React.createElement(ListItemText, { primary: title }),
                        result.checked ? (React.createElement(CheckCircleRounded, { fontSize: 'small', color: 'success' })) : (React.createElement(ErrorRounded, { fontSize: 'small', color: 'error' }))),
                    result.comment && (React.createElement(Box, { sx: () => ({
                            paddingLeft: '20px',
                        }) },
                        React.createElement(ListItemText, { primary: '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:' }),
                        React.createElement(Typography, { variant: 'body2' }, result.comment))),
                    result.photo && (React.createElement(Box, { sx: () => ({
                            paddingLeft: '20px',
                            width: '100%',
                        }) },
                        React.createElement(ListItemText, { primary: '\u0424\u043E\u0442\u043E:' }),
                        React.createElement(Box, { component: 'div', sx: {
                                width: '100%',
                                height: '200px',
                                bgcolor: 'black',
                                'a, img': {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                },
                            } },
                            React.createElement("a", { href: `${location.origin}/resources/${result.photo}`, target: '_blank' },
                                React.createElement("img", { src: `${location.origin}/resources/${result.photo}`, alt: 'inspection photo' })))))))) : (React.createElement(ListItem, { "data-error": status, key: index },
                React.createElement(ListItemText, { primary: title }),
                result ? React.createElement(CheckCircleRounded, { fontSize: 'small', color: 'success' }) : React.createElement(ErrorRounded, { fontSize: 'small', color: 'error' })));
        default:
            return null;
    }
};
const ChecklistInspectionView = () => {
    var _a, _b, _c, _d, _e;
    const [tab, setTab] = useState('info');
    const { inspectionSelectedItem } = useSelector((state) => state.checklist);
    return (React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
            height: '100%',
            '& .MuiTabPanel-root': {
                width: '100%',
                padding: theme.spacing(2),
            },
            '& .MuiTabs-root': {
                padding: theme.spacing(2),
            },
        }) },
        inspectionSelectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                maxWidth: '540px',
                width: '100%',
                height: 'auto',
                padding: theme.spacing(2),
            }) },
            React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                    marginBottom: theme.spacing(3),
                    '.MuiAvatar-root': {
                        width: '56px',
                        height: '56px',
                        bgcolor: theme.palette.primary.main,
                    },
                    '.MuiAvatar-circular': {
                        color: theme.palette.primary.main,
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                        svg: {
                            width: '30px',
                            height: '30px',
                        },
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                    '.MuiTypography-root:first-of-type': {
                        marginTop: theme.spacing(1),
                    },
                }) },
                React.createElement(Avatar, null,
                    React.createElement(InspectionIcon, { fontSize: 'large' })),
                React.createElement(Typography, { variant: 'body1' }, String((_a = inspectionSelectedItem.name) !== null && _a !== void 0 ? _a : ''))),
            React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                    width: '100%',
                    height: 'auto',
                    position: 'relative',
                    border: '1px solid',
                    borderRadius: theme.shape.borderRadius,
                    borderColor: theme.palette.divider,
                    bgcolor: 'background.paper',
                }) },
                React.createElement(TabContext, { value: tab },
                    React.createElement(TabList, { onChange: (event, value) => setTab(value), TabIndicatorProps: { children: React.createElement("span", null) }, sx: (theme) => ({
                            width: '100%',
                            minHeight: '44px',
                            borderBottom: '1px solid',
                            borderColor: theme.palette.divider,
                            '.MuiTab-root': {
                                fontSize: '12px',
                                minHeight: '44px',
                                padding: theme.spacing(2),
                                '&.Mui-selected': {
                                    color: 'inherit',
                                },
                                '&:first-of-type': {
                                    paddingLeft: 0,
                                },
                            },
                            '.MuiTabs-indicator': {
                                display: 'flex',
                                justifyContent: 'center',
                                backgroundColor: 'transparent',
                            },
                            '.MuiTabs-indicator span': {
                                width: 'calc(100% - ' + theme.spacing(4) + ')',
                                bgcolor: theme.palette.primary.main,
                                borderRadius: theme.shape.borderRadius,
                            },
                        }) },
                        React.createElement(Tab, { value: 'info', label: '\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F', disableRipple: true }),
                        React.createElement(Tab, { value: 'result', label: '\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043E\u0441\u043C\u043E\u0442\u0440\u0430', disableRipple: true })),
                    React.createElement(TabPanel, { value: 'info' },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                position: 'relative',
                                gap: '6px',
                                '.MuiPaper-label': {
                                    position: 'absolute',
                                    top: '10px',
                                    left: theme.spacing(1),
                                    padding: theme.spacing(0, 1),
                                    bgcolor: 'background.paper',
                                    fontWeight: '500',
                                },
                                '.MuiPaper-row': {
                                    display: 'grid',
                                    gap: 1,
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    '.MuiTypography-root:first-of-type': {
                                        color: 'text.secondary',
                                    },
                                },
                                '.MuiPaper-row .MuiTypography-root:first-of-type': {
                                    gridRow: '1',
                                    gridColumn: '1/3',
                                },
                                '.MuiPaper-row .MuiTypography-root:last-of-type': {
                                    gridRow: '1',
                                    gridColumn: '3/5',
                                    'span:nth-of-type(2)': {
                                        paddingLeft: theme.spacing(0.5),
                                    },
                                },
                            }) },
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u043C\u043E\u0442\u0440\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, String((_b = inspectionSelectedItem.name) !== null && _b !== void 0 ? _b : ''))),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0420\u0435\u0436\u0438\u043C \u043E\u0441\u043C\u043E\u0442\u0440\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, formatInspectionModeLabel(inspectionSelectedItem.inspection_mode))),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0411\u043B\u043E\u043A \u0441\u0430\u043C\u043C\u0430\u0440\u0438"),
                                React.createElement(Typography, { variant: 'body1' }, formatSummaryPositionLabel(inspectionSelectedItem.inspection_mode, inspectionSelectedItem.summary_position))),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0412\u0440\u0435\u043C\u044F \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0441\u043C\u043E\u0442\u0440\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, moment(inspectionSelectedItem.created_at).format('DD.MM.YYYY HH:mm:ss'))),
                            inspectionSelectedItem.delivered_at ? (React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E"),
                                React.createElement(Typography, { variant: 'body1' }, moment(inspectionSelectedItem.delivered_at).format('DD.MM.YYYY HH:mm:ss')))) : null,
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B"),
                                React.createElement(Typography, { variant: 'body1' },
                                    String((_c = inspectionSelectedItem.latitude) !== null && _c !== void 0 ? _c : ''),
                                    ", ",
                                    String((_d = inspectionSelectedItem.longitude) !== null && _d !== void 0 ? _d : ''))),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u0422\u0421"),
                                React.createElement(Typography, { variant: 'body1' }, inspectionSelectedItem.number)),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0438\u0446\u0435\u043F\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, inspectionSelectedItem.trailer)),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0424\u0418\u041E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, inspectionSelectedItem.employee)),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                                React.createElement(Typography, { variant: 'body1' }, config.inspectionStatuses.find((item) => item.value === inspectionSelectedItem.status).label)))),
                    React.createElement(TabPanel, { value: 'result' }, !inspectionSelectedItem.details_loaded ? (React.createElement(Stack, { alignItems: 'center', justifyContent: 'center', sx: { minHeight: 160 } },
                        React.createElement(CircularProgress, { size: 24 }))) : (React.createElement(List, { sx: (theme) => ({
                            '.MuiListItem-root': {
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                borderRadius: theme.spacing(1),
                                marginBottom: theme.spacing(2),
                                '&[data-error="true"]': {
                                    borderColor: theme.palette.error.main,
                                },
                                '&:last-of-type': {
                                    marginBottom: 0,
                                },
                                '.MuiListItemText-root:nth-of-type(1) span': {
                                    color: theme.palette.text.secondary,
                                },
                                '.MuiListItemText-root:nth-of-type(2)': {
                                    textAlign: 'right',
                                },
                            },
                        }) }, ((_e = inspectionSelectedItem.checkpoints) !== null && _e !== void 0 ? _e : []).map((checkpoint, index) => {
                        if (checkpoint.length === 2) {
                            const [title, data] = checkpoint;
                            const results = inspectionSelectedItem.results;
                            return (React.createElement(Stack, { key: index, direction: 'column', sx: (theme) => ({
                                    marginBottom: theme.spacing(2),
                                    paddingBottom: theme.spacing(2),
                                    borderBottom: '1px solid',
                                    borderColor: theme.palette.divider,
                                }) },
                                React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                                        width: '100%',
                                        alignSelf: 'center',
                                        justifyContent: 'center',
                                        marginTop: theme.spacing(0),
                                        marginBottom: theme.spacing(2),
                                    }) },
                                    React.createElement(Typography, { variant: 'body2' }, title)),
                                data.map((nestedCheckpoint, subIndex) => {
                                    var _a;
                                    return (React.createElement(ChecklistInspectionViewItem, { key: `${index}.${subIndex}`, checkpoint: nestedCheckpoint, result: (_a = results[index]) === null || _a === void 0 ? void 0 : _a[subIndex], index: `${index}.${subIndex}` }));
                                })));
                        }
                        else {
                            const results = inspectionSelectedItem.results;
                            return React.createElement(ChecklistInspectionViewItem, { key: index, checkpoint: checkpoint, result: results[index], index: index });
                        }
                    })))))))),
        !inspectionSelectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                height: '100%',
                padding: theme.spacing(0, 2),
                '.MuiTypography-root': {
                    borderRadius: '20px',
                    marginTop: '24px',
                    padding: theme.spacing(0.5, 2),
                    bgcolor: alpha(theme.palette.grey.main, 0.12),
                },
            }) },
            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0441\u043C\u043E\u0442\u0440 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430")))));
};
export default ChecklistInspectionView;
